<template>
  <div class="ai-item">
    <el-input :value="item.id" class="ai-item-no" title="数据唯一值，自动生成" disabled/>
    <el-select v-model="item.type" class="mr8" style="width: 100px;">
      <el-option :value="0" label="词汇"></el-option>
      <el-option :value="1" label="语法"></el-option>
    </el-select>
    <WordSelect v-if="item.type !== 1" v-model="itemId" class="flex1" :on-select="handleSelect"/>
    <GrammarSelect v-if="item.type === 1" v-model="itemId" class="flex1" :on-select="handleSelect"/>
    <el-input v-model="item.text"></el-input>
    <slot/>
  </div>
</template>

<script>
import WordSelect from "@/components/word/WordSelect.vue";
import GrammarSelect from "@/components/grammar/GrammarSelect.vue";

export default {
  name: "ai_word_item",
  components: {GrammarSelect, WordSelect},
  props: {
    item: Object
  },
  computed: {
    itemId: {
      get() {
        if (typeof this.item.type === 'number') {
          return this.item.id >> 2;
        }
        return this.item.id
      },
      set(val) {
        this.item.id = val << 2 | this.item.type;
      }
    }
  },
  methods: {
    handleSelect(item) {
      this.item.text = item.text;
    }
  }
}
</script>